import { useDataSubmit } from 'Simple/Data.js'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'card',
    viewPath: props.viewPath,
  })

  return function onChange() {
    submit({
      type: 'TOGGLE_SELECTION',
    })
  }
}
